/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */
/* eslint-disable @typescript-eslint/no-empty-object-type */
// This is an intentional hack to enable dynamic property access e.g. `iconService.cancelIcon`
// Feel free to find a better way!
import { Injectable } from '@angular/core';
import {
  arrowLeftIcon,
  arrowRightIcon,
  arrowsSwapIcon,
  arrowUpIcon,
  binocularsIcon,
  buildingsSolidIcon,
  cancelIcon,
  checkboxCheckedIcon,
  checkboxIcon,
  chevronLeftIcon,
  chevronRightIcon,
  chevronUpIcon,
  clipboardTextIcon,
  clockArrowRotateIcon,
  commentIcon,
  connectorIcon,
  dataIcon,
  dollarIcon,
  downloadIcon,
  downloadLightIcon,
  editAnnotationsIcon,
  envelopeIcon,
  eyeIcon,
  fileIcon,
  formElementIcon,
  gearIcon,
  gearsIcon,
  globeIcon,
  handIcon,
  heartIcon,
  homeIcon,
  hyperlinkOpenIcon,
  infoSolidIcon,
  listUnorderedSquareIcon,
  lockIcon,
  logoutIcon,
  menuIcon,
  moneyExchangeIcon,
  moreHorizontalIcon,
  myspaceIcon,
  pageHeaderSectionIcon,
  pencilIcon,
  plusCircleIcon,
  plusIcon,
  positionLeftIcon,
  questionSolidIcon,
  radiobuttonCheckedIcon,
  radiobuttonIcon,
  redoIcon,
  replaceSingleIcon,
  saveIcon,
  setColumnPositionIcon,
  SVGIcon,
  tableCellPropertiesIcon,
  trackChangesEnableIcon,
  unlockIcon,
  uploadIcon,
  userIcon,
  userOutlineIcon,
  xCircleIcon,
} from '@progress/kendo-svg-icons';

export const icons = {
  arrowLeftIcon,
  homeIcon,
  userOutlineIcon,
  uploadIcon,
  gearIcon,
  gearsIcon,
  logoutIcon,
  userIcon,
  myspaceIcon,
  plusCircleIcon,
  setColumnPositionIcon,
  connectorIcon,
  pageHeaderSectionIcon,
  downloadLightIcon,
  xCircleIcon,
  eyeIcon,
  saveIcon,
  pencilIcon,
  moreHorizontalIcon,
  chevronUpIcon,
  unlockIcon,
  lockIcon,
  cancelIcon,
  clipboardTextIcon,
  listUnorderedSquareIcon,
  arrowsSwapIcon,
  handIcon,
  heartIcon,
  downloadIcon,
  formElementIcon,
  checkboxCheckedIcon,
  dollarIcon,
  commentIcon,
  trackChangesEnableIcon,
  clockArrowRotateIcon,
  checkboxIcon,
  editAnnotationsIcon,
  binocularsIcon,
  radiobuttonCheckedIcon,
  radiobuttonIcon,
  hyperlinkOpenIcon,
  arrowRightIcon,
  menuIcon,
  envelopeIcon,
  chevronRightIcon,
  chevronLeftIcon,
  replaceSingleIcon,
  dataIcon,
  arrowUpIcon,
  infoSolidIcon,
  redoIcon,
  plusIcon,
  positionLeftIcon,
  tableCellPropertiesIcon,
  questionSolidIcon,
  fileIcon,
  moneyExchangeIcon,
  buildingsSolidIcon,
  globeIcon,
} as const;

export type IconName = keyof typeof icons;

@Injectable({
  providedIn: 'root',
})
export class IconService {
  public constructor() {
    for (const iconName of Object.keys(icons) as IconName[]) {
      Object.defineProperty(this, iconName, {
        get: () => {
          return icons[iconName];
        },
        enumerable: true, // Ensure properties show up in enumeration
      });
    }
  }

  public getSVGIcon(name: IconName) {
    return icons[name];
  }
}

export interface IconService extends Record<IconName, SVGIcon> {}
